import React from 'react';
import ReactDOM from 'react-dom/client';
import WebChatApp from './WebChatApp';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'font-awesome/css/font-awesome.min.css';
import '../app/globals.css';

class ViteoWebChat {
  constructor() {
    this.iframe = null;
    this.isOpen = false;
    this.container = null;
    this.root = null;
  }

  /**
   * Inicializa el webchat en el sitio
   * @param {Object} options - Opciones de configuración
   * @param {string} options.containerId - ID del contenedor donde se renderizará (por defecto: 'viteo-webchat-container')
   * @param {string} options.channel - Canal de comunicación (ej: 'teams', 'web')
   * @param {string} options.aadUserId - ID del usuario de Azure AD
   * @param {boolean} options.autoOpen - Abrir automáticamente el chat (por defecto: false)
   * @param {Function} options.onMinimize - Callback cuando se minimiza el chat
   * @param {boolean} options.showLauncher - Mostrar botón flotante (por defecto: true)
   */
  init(options = {}) {
    const {
      containerId = 'viteo-webchat-container',
      channel = '',
      aadUserId = '',
      autoOpen = false,
      onMinimize = null,
      showLauncher = true
    } = options;

    // Crear contenedor si no existe
    let container = document.getElementById(containerId);
    if (!container) {
      container = document.createElement('div');
      container.id = containerId;
      document.body.appendChild(container);
    }

    this.container = container;

    // Si showLauncher, crear el botón flotante
    if (showLauncher) {
      this.createLauncher();
    }

    // Crear contenedor para el iframe/chat
    const chatWrapper = document.createElement('div');
    chatWrapper.id = 'viteo-chat-wrapper';
    chatWrapper.style.cssText = `
      position: fixed;
      bottom: 0;
      right: 12px;
      z-index: 1000;
      display: ${autoOpen ? 'block' : 'none'};
      width: 400px;
      height: 470px;
      background-color: white;
      border-radius: 10px;
      box-shadow: 0 4px 16px rgba(0,0,0,0.2);
    `;

    this.container.appendChild(chatWrapper);

    // Renderizar React app
    this.root = ReactDOM.createRoot(chatWrapper);
    
    // DEBUG: Verificar variables de entorno
    console.log('🔍 DEBUG - Variables en bundle:');
    console.log('NEXT_PUBLIC_AD_CLIENT_ID:', process.env.NEXT_PUBLIC_AD_CLIENT_ID);
    console.log('NEXT_PUBLIC_AD_TENANT_ID:', process.env.NEXT_PUBLIC_AD_TENANT_ID);
    
    this.root.render(
      <WebChatApp
        config={{
          channel,
          aadUserId,
          onMinimize: () => {
            this.hide();
            if (onMinimize) onMinimize();
          }
        }}
      />
    );

    this.chatWrapper = chatWrapper;
    this.isOpen = autoOpen;

    return this;
  }

  createLauncher() {
    const launcher = document.createElement('div');
    launcher.id = 'viteo-chat-launcher';
    launcher.style.cssText = `
      position: fixed;
      bottom: 0px;
      right: 12px;
      z-index: 999;
      width: 170px;
      height: 157px;
      background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mNk+M9QDwADhgGAWjR9awAAAABJRU5ErkJggg==");
      background-size: cover;
      cursor: pointer;
      transition: transform 0.2s;
    `;

    // Imagen del asistente (puedes cambiar esta URL)
    launcher.style.backgroundImage = 'url("https://avviteo-dev.afpcapital.cl/asistente_th_logo.png")';

    launcher.addEventListener('click', () => {
      this.toggle();
    });

    launcher.addEventListener('mouseenter', () => {
      launcher.style.transform = 'scale(1.05)';
    });

    launcher.addEventListener('mouseleave', () => {
      launcher.style.transform = 'scale(1)';
    });

    this.container.appendChild(launcher);
    this.launcher = launcher;
  }

  show() {
    if (this.chatWrapper) {
      this.chatWrapper.style.display = 'block';
      this.isOpen = true;
      if (this.launcher) {
        this.launcher.style.display = 'none';
      }
    }
  }

  hide() {
    if (this.chatWrapper) {
      this.chatWrapper.style.display = 'none';
      this.isOpen = false;
      if (this.launcher) {
        this.launcher.style.display = 'block';
      }
    }
  }

  toggle() {
    if (this.isOpen) {
      this.hide();
    } else {
      this.show();
    }
  }

  destroy() {
    if (this.root) {
      this.root.unmount();
    }
    if (this.container) {
      this.container.remove();
    }
    this.iframe = null;
    this.container = null;
    this.root = null;
  }
}

// Exportar como módulo y también como global
const viteoWebChat = new ViteoWebChat();

if (typeof window !== 'undefined') {
  window.ViteoWebChat = viteoWebChat;
}

export default viteoWebChat;
